import React from 'react';
import { classnames } from 'utils';
import { Feed, ToggleList } from 'components';
import { Button } from 'elements';
import { Hat } from 'components/Hat/Hat';

import { getFeedList, getMoreId, portfolioFilters, protfolioFeedKeys } from './utils';

const cl = classnames('main projects-listing');
const ProjectsMain = (props) => {
  const [filters, setFilters] = React.useState([]);
  const [activeFilters, setActiveFilters] = React.useState([]); // string[]
  const [feed, setFeed] = React.useState(getFeedList('main', props.feed, { keys: protfolioFeedKeys }));

  const id = props.id;

  const projectsList = feed.map((i) => i.id);

  const toggleListItems = (items) => {
    return [
      ...items.map((tag) => (
        <Button
          size="s"
          key={tag}
          onClick={() => onClickTag(tag)}
          className={classnames(checkActiveTag(tag) && 'active')}
        >
          {tag.replace('m/', '')}
        </Button>
      )),
      activeFilters.length ? (
        <Button size="s" onClick={onClickReset} className="reset">
          Сбросить фильтр
        </Button>
      ) : null
    ];
  };

  function checkActiveTag(tag) {
    return !!activeFilters.find((i) => i === tag);
  }

  function updateFilters() {
    setFilters(() => {
      if (window.innerWidth < 950) {
        return portfolioFilters.filter((i) => i.split('/')?.[0] === 'm');
      } else {
        return portfolioFilters.filter((i) => i.split('/')?.[0] !== 'm');
      }
    });
  }

  function onClickTag(tag) {
    setActiveFilters((prev) => {
      if (window.innerWidth < 950) {
        return [tag];
      }
      if (checkActiveTag(tag)) {
        return prev.filter((i) => i !== tag);
      } else {
        return [
          // ...prev,
          tag
        ];
      }
    });
  }

  function onClickReset() {
    setActiveFilters([]);
  }

  const handleWindowResize = () => {
    updateFilters();

    setActiveFilters((prev) => {
      if (prev.length) return [];
      return prev;
    });
  };

  function updateFeed() {
    setFeed(getFeedList('portfolio', props.feed, { filters: activeFilters, keys: protfolioFeedKeys }));
  }

  React.useEffect(() => {
    updateFeed();
  }, [activeFilters]);

  React.useEffect(() => {
    updateFilters();
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return (
    <div className={classnames(cl, props.className)} id={id}>
      <Hat title="Наши проекты" as="h2" />
      {/**
       * filters
       */}
      <div className={classnames(cl, 'filter')}>
        <div className={classnames(cl, 'filter-list')}>
          <ToggleList items={toggleListItems(filters)} />
        </div>
      </div>
      {/**
       * Листинг главной страницы
       */}
      <div className={classnames(cl, 'projects-feed')}>
        <Feed list={[...projectsList.slice(0, 8), getMoreId(activeFilters[0]) || 'more/all']} />
      </div>
    </div>
  );
};

export default ProjectsMain;
